module.exports = __webpack_public_path__ + "img/001徐向南.b43384dc.png";